import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuánto tiempo toma vaciar un piso?',
      answer: 'El tiempo depende del tamaño del piso y la cantidad de objetos. Generalmente, un piso estándar de 60-80m² se puede vaciar en 4-8 horas. Para pisos más grandes o con mucho contenido, puede tomar entre 1 y 2 días. Siempre nos adaptamos a tus necesidades y plazos.'
    },
    {
      question: '¿Qué objetos se pueden retirar en un vaciado de piso?',
      answer: 'Retiramos todo tipo de objetos: muebles (sofás, armarios, camas, mesas), electrodomésticos (neveras, lavadoras, hornos), ropa, libros, enseres personales, escombros, residuos en general. Si hay objetos especiales o peligrosos, consúltanos previamente.'
    },
    {
      question: '¿Qué pasa con los objetos retirados?',
      answer: 'Gestionamos todos los residuos de forma responsable y legal. Los objetos en buen estado se donan a entidades benéficas, los materiales reciclables se llevan a puntos limpios autorizados, y el resto se elimina siguiendo la normativa medioambiental vigente.'
    },
    {
      question: '¿Tengo que estar presente durante el vaciado?',
      answer: 'No es imprescindible. Si contratas nuestro servicio completo y nos das las indicaciones necesarias, nuestro equipo profesional puede realizar el trabajo sin tu presencia. Contamos con seguro de responsabilidad civil que cubre cualquier incidencia.'
    },
    {
      question: '¿Cuánto cuesta vaciar un piso en Barcelona?',
      answer: 'El precio varía según el tamaño del piso, cantidad de objetos, accesibilidad y servicios adicionales. Los precios suelen empezar desde 200€ para pisos pequeños. Te ofrecemos un presupuesto gratuito y sin compromiso tras evaluar tu caso específico.'
    },
    {
      question: '¿Puedo solicitar solo la retirada de ciertos objetos?',
      answer: 'Sí, por supuesto. Ofrecemos servicios flexibles adaptados a tus necesidades. Puedes contratar desde la retirada de un solo mueble hasta el vaciado completo del piso. Consúltanos y te daremos la mejor solución.'
    },
    {
      question: '¿Ofrecen servicio de limpieza después del vaciado?',
      answer: 'Sí, ofrecemos servicios adicionales de limpieza profunda y desinfección. Es ideal si necesitas dejar el piso en perfectas condiciones para entrega, venta o alquiler. Podemos incluirlo en el presupuesto del vaciado.'
    },
    {
      question: '¿Trabajan los fines de semana?',
      answer: 'Sí, trabajamos de lunes a sábado en horario de 8:00 a 20:00. Los domingos también podemos trabajar bajo consulta previa, especialmente para casos urgentes. Nos adaptamos a tu disponibilidad.'
    },
    {
      question: '¿Qué zonas de Barcelona cubren?',
      answer: 'Cubrimos toda Barcelona ciudad y el área metropolitana: Hospitalet, Badalona, Santa Coloma, Cornellà, Sant Adrià, Esplugues, y otras localidades cercanas. Consúltanos si tu ubicación está fuera de estas zonas.'
    },
    {
      question: '¿Necesito permisos especiales para el vaciado?',
      answer: 'Normalmente no se necesitan permisos especiales para el vaciado interior. Si es necesario ocupar la vía pública con un contenedor o vehículo, nosotros nos encargamos de gestionar los permisos necesarios con el ayuntamiento.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-12 sm:py-16 md:py-20 bg-white overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-teal-600 font-semibold text-sm sm:text-base uppercase tracking-wide">
            Preguntas Frecuentes
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mt-2 mb-4 px-2">
            Resolvemos tus dudas sobre el vaciado de pisos
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto px-4">
            Encuentra respuestas a las preguntas más comunes sobre nuestro servicio de vaciado de pisos en Barcelona.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200 hover:border-teal-300 transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-100 transition-colors"
              >
                <h3 className="text-base sm:text-lg font-semibold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-teal-600 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-5">
                  <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center bg-teal-50 rounded-xl p-6 sm:p-8">
          <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3">
            ¿No encuentras la respuesta que buscas?
          </h3>
          <p className="text-sm sm:text-base text-gray-600 mb-5">
            Nuestro equipo está disponible para resolver cualquier duda adicional que tengas.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <a
              href="tel:629501941"
              className="inline-flex items-center gap-2 bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line text-lg"></i>
              Llámanos: 629 501 941
            </a>
            <button
              onClick={() => {
                const element = document.getElementById('contacto');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 bg-white text-teal-600 px-6 py-3 rounded-lg text-sm font-semibold hover:bg-gray-50 transition-colors border border-teal-600 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              Envíanos un mensaje
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
